import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationsDataService } from 'src/app/notifications/data-access/notifications-data.service';

interface CreateProjectWatchDialogData {
    projectId: number;
    projectName: string;
}

@Component({
    selector: 'eic-create-project-watch-dialog',
    templateUrl: './create-project-watch-dialog.component.html',
    styleUrl: './create-project-watch-dialog.component.scss'
})
export class CreateProjectWatchDialogComponent {
    isSaving = false;
    error: string | null = null;

    constructor(
        private dialogRef: MatDialogRef<CreateProjectWatchDialogComponent>,
        private notificationsDataService: NotificationsDataService,
        @Inject(MAT_DIALOG_DATA) public data: CreateProjectWatchDialogData
    ) { }

    cancel(): void {
        this.dialogRef.close();
    }

    save(): void {
        if (this.isSaving) return;

        this.isSaving = true;
        this.error = null;

        // Payload shape mirrors the legacy INDIVIDUAL_PROJECT watch request (dialogService.js)
        this.notificationsDataService
            .createWatch({
                createReason: 4,
                watchType: 'selectedProjects',
                title: this.data.projectName,
                description: '',
                heading: 'Watch Selected Projects',
                narrative: 'Tell me when changes are made to any of the selected projects',
                projectIDs: [this.data.projectId]
            })
            .subscribe({
                next: (watch) => this.dialogRef.close(watch),
                error: () => {
                    this.isSaving = false;
                    this.error = 'There was a problem creating this watch. Please try again.';
                }
            });
    }
}


